import { Editor, TLVideoAsset } from '@tldraw/tldraw'
import { VideoShape } from 'components/VisualStudioPlayground/Shapes/VideoShape/Types'
import { getCurrentFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { fitAndPosition } from 'object-fit-math'
import { FitMode } from 'object-fit-math/dist/types'

export const fitAndPositionShape = (editor: Editor, selectedShape: VideoShape, fitMode: FitMode) => {
  if (!selectedShape.props.assetId) return

  const asset = editor.getAsset(selectedShape.props.assetId) as TLVideoAsset | undefined
  if (!asset) return

  const frame = getCurrentFrame(editor)
  const filledVideo = fitAndPosition(
    { width: frame.props.w, height: frame.props.h },
    { width: asset.props.w, height: asset.props.h },
    fitMode,
  )

  editor.updateShape({
    ...selectedShape,
    x: frame.props.w / 2 - filledVideo.width / 2,
    y: frame.props.h / 2 - filledVideo.height / 2,
    props: {
      ...selectedShape.props,
      w: filledVideo.width,
      h: filledVideo.height,
    },
  })
}
